import {useMutation, useQuery} from '@tanstack/react-query';
import axiosClient from '../services/axiosClient';

export const useGetTestSubmissionQuery = (params) => {
  return useQuery(['testSubmission', params], async () => {
    const {data} = await axiosClient.get('/test/problemTest', {
      params,
    });
    return data;
  });
};

export const useGetOneTestSubmissionDetailQuery = (testId) => {
  return useQuery(
    [testId],
    async () => {
      const {data} = await axiosClient.get(`/test/problemTest/${testId}`);
      return data;
    },
    {
      enabled: !!testId,
      keepPreviousData: false,
      cacheTime: 0,
    },
  );
};

export const useRunTestproblem = () =>
  useMutation(async (payload) => {
    const {data} = await axiosClient.post('/test/runProblemTest', payload);
    return data;
  });

export const useSubmitScoreMutation = () =>
  useMutation(async ({testId, ...payload}) => {
    const {data} = await axiosClient.patch(
      `/test/problemTest/${testId}`,
      payload,
    );
    return data;
  });
